"use client";

import {
  AlertTriangle,
  BarChart3,
  Bell,
  CheckCircle2,
  ClipboardList,
  CreditCard,
  GraduationCap,
  MessageCircle,
  Rocket,
  UserPlus,
  Users,
  type LucideIcon,
} from "lucide-react";
import { getNotificationPriorityTheme } from "@/app/lib/util/notification-priority.util";

const TYPE_ICON_MAP: Record<string, LucideIcon> = {
  analysis_ready: BarChart3,
  session_created: MessageCircle,
  session_finished: CheckCircle2,
  account_upgrade: Rocket,
  generic: Bell,
  kyc_pending: ClipboardList,
  subscription_ending: CreditCard,
  subscription_expired: CreditCard,
  subscription_update: CreditCard,
  payment_success: CreditCard,
  payment_failed: CreditCard,
  onboarding_incomplete: ClipboardList,
  personalisation_incomplete: ClipboardList,
  members_added: UserPlus,
  members_updated: Users,
  members_deleted: Users,
  trainee_added: GraduationCap,
  trainees_updated: GraduationCap,
  guardians_updated: Users,
  profile_update: Users,
  user_update: Users,
  red_flag: AlertTriangle,
};

interface NotificationTypeIconProps {
  type: string;
  priority?: string | null;
  className?: string;
}

export default function NotificationTypeIcon({
  type,
  priority,
  className = "",
}: NotificationTypeIconProps) {
  const Icon = TYPE_ICON_MAP[type] ?? Bell;
  const theme = getNotificationPriorityTheme(type, priority);

  return (
    <span
      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border ${theme.icon} ${className}`}
      aria-hidden="true"
    >
      <Icon size={18} strokeWidth={1.75} />
    </span>
  );
}
